<template>
  <div>
    <v-card>
      <v-btn
        dark
        absolute
        fixed
        bottom
        large
        right
        fab
        color="primary"
        @click="dialog = !dialog"
        class="mr-4 mb-16 fabNav"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Formations de groupe
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="FormationsDeGroupe"
        :search="search"
      ></v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Formation", value: "ll_formation_groupe" },
        { text: "Projet", value: "ll_programme" },
        { text: "Activité", value: "ll_parcours" },
        { text: "Groupe", value: "nom_groupe" },

        { text: "Date", value: "date_formation_groupe" },
        { text: "Responsable", value: "nom_responsable" },
        {
          text: "Nb Présents",
          value: "presence",
          label: "Nb Présents",
          field: "presence",
        },

        {
          text: "Totaux Femmes",
          value: "nbFemme",
          label: "Femmes",
          field: "nbFemme",
        },
        {
          text: "Totaux Hommes",
          value: "nbHomme",
          label: "Hommes",
          field: "nbHomme",
        },

        {
          text: "Détails Femmes",
          value: "nbDetailFemme",
          label: "Détails Femmes",
          field: "nbDetailFemme",
        },
        {
          text: "Détails Hommes",
          value: "nbDetailHomme",
          label: "Détails Hommes",
          field: "nbDetailHomme",
        },

        {
          text: "Région",
          value: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
        },
        {
          text: "Thème",
          value: "ll_theme",
        },
      ],
    };
  },
  created() {
    this.GetFormationsDeGroupe();
  },
  methods: {
    ...mapActions({
      GetFormationsDeGroupe: "FormationsDeGroupe/GetAll",
    }),
  },
  computed: {
    ...mapState({
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
